import { Cards } from '../../../components/cards/frame/cards-frame';
import compassImg from '../../../static/img/dashboard/compass.svg';
function AttendanceRule() {
  return (
    <div>
      <Cards
        title="ATTENDANCE RULE"
        headless={false}
        border={true}
        className="overview-custom-card"
      >
        <div class="attendance-rule-card">
          <div class="rule-content">
            <div class="rule-item">
              <span class="diamond-icon">✦</span>
              <p>
                <strong>For Full Day: Mon - Sat between 09:00 AM</strong>
                <br />
                and 06:00 PM, with 4-hour.
              </p>
            </div>

            <div class="rule-item">
              <span class="diamond-icon">✦</span>
              <p>
                <strong>If login occurs between 12:00 PM</strong>
                <br />
                and 02:00 PM, count as Half Day.
              </p>
            </div>
          </div>

          <div class="compass-icon">
            <img src={compassImg} alt="Compass" />
          </div>
        </div>
      </Cards>
    </div>
  );
}

export default AttendanceRule;
